<template>
  <div class="yunxiao teacher duplicate-checking">
    <div class="main">
      <div class="top-tips">
        启用限制后，新增意向和学员时，若与系统已有数据重复，则无法继续保存  
        <span style="color:var(--tlc);" @click="showExample=true"> 查看配置示例</span>
      </div>
      <!-- <van-cell-group v-for="(item,idx) of params.filter(v=>v.studentType!==1)" :key="idx" > -->
      <van-cell-group v-for="(item,idx) of params" :key="idx" >
        <van-cell class="check-cell">
          <template #title>
            <span class="custom-title">不允许录入重复的<span class="important">{{`${item.studentType === 1 ? '学员': '意向'}`}}</span></span>
          </template>
          <van-switch 
            v-model="item.status" 
            size="26" 
            :active-value="1" 
            :inactive-value="0"
            :disabled="item.studentType === 1 && item.status === 1" 
            @change="submit(false)"/>
        </van-cell>
        <van-cell class="check-cell"  v-if="item.status"  >
          <template #title>
            <span style="color: var(--g5);">- </span> 重复范围
          </template>
          <!-- :class="{disabled: item.studentType === 1 && item.status === 1}"  -->
          <div class="cell-val-div" 
            @click="pickCheckingType(item)">            
            <span>{{getDuplicateScopeText(item)}}</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </div>
        </van-cell>   
        <van-cell class="check-cell"  v-if="item.status"  >
          <template #title>
            <span style="color: var(--g5);">- </span> 重复类型
          </template>
          姓名及手机号码重复
        </van-cell>  
        <!-- <div class="top-tips" >
          注：在学员下添加不同意向时，不会受到重复限制
        </div>  -->
      </van-cell-group>       
    </div>
    
    <page-footer-btn multipleBtns>
      <van-button
        square round
        block
        type="primary"
        @click="submit"
        loading-text="保存中..."
        :loading="isSubmit"
        data-test="add-clue-page-btn-add">
          保存
        </van-button>
    </page-footer-btn>
    <transition name="van-fade">
      <div class="example-layer" v-if="showExample">
        <div class="example-body">
          <p>如图配置即代表：新增意向时，若与系统的全部意向和学员，有相同的姓名及手机号码，则无法继续保存</p>
          <img
            class="non-full"
            src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0084.png?v=2"
            alt=""
          />
          <button @click="showExample = false">我知道了</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'duplicate-checking',
  data(){
    return {
      pageTitle: '重复数据限制',
      duplicateScopeType: [
        [],
        [
          {
            id: 0,
            dictName: '全部意向和学员',
          },
          {
            id: 1,
            dictName: '仅学员',
          },
        ],
        [
          {
            id: 0,
            dictName: '全部意向和学员',
          },
          {
            id: 2,
            dictName: '仅意向',
          },
        ],

      ],
      params: [],
      isSubmit: false,
      showExample: false,

    }
  },
  methods: {
    getDuplicateScopeText (item) {
      let { duplicateScopeType } = this;
      let duplicateScopeObjs = duplicateScopeType[item.studentType];
      if (duplicateScopeObjs && duplicateScopeObjs.length) {
        if (item.duplicateScope && item.duplicateScope.length>1) {
          return duplicateScopeObjs[0].dictName
        }

        if (item.duplicateScope && item.duplicateScope.length === 1) {
          return duplicateScopeObjs[1].dictName
        }

        return '-'
      }

      return '-';

    },
    getConfigDatas () {
      return this.$api.getDuplicateRule()
        .then(res=>{
          if (res.code === 200) {
            this.params.splice(0);
            this.params.push(...res.data);
          }
        })
    },
    pickCheckingType (item) {
      // 学员限制重复范围不可修改
      // if (item.studentType === 1){
      //   return false
      // }
      let { duplicateScopeType } = this;
      let list = duplicateScopeType[item.studentType];
      let pickerParams = {
        title: '请选择',
        list,
      }

      if (list && list.length) {
        if (item.duplicateScope && item.duplicateScope.length>1) {
          pickerParams.default = list[0].id
        }

        if (item.duplicateScope && item.duplicateScope.length === 1) {
          pickerParams.default = list[1].id
        }
      }

      app.x3.picker
        .dictionary(pickerParams)
        .then((res) => {
          if (res.id === 0) {
            item.duplicateScope = [1,2];
          } else {
            item.duplicateScope = [res.id]
          }
        });
    },
    submit (isShowLoading = true) {
      if (isShowLoading) {
        this.showLoading();
      }
      this.$api.updateDuplicateRule({rules: this.params})
        .then(res=>{
          if (res.code === 200 && isShowLoading) {
            this.$toast.success('保存成功');
            setTimeout(() => {
              this.$router.back();
            }, 50);
          }
          if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          console.log(err)
        });
    }
  },
  async created () {
    this.showLoading();
    try {
      await this.getConfigDatas();
    } catch(err){
      console.log(err);
    }
    this.$toast.clear();
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.duplicate-checking{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    .top-tips{
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
    }
    .top-tips{
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g6);
    }
    ::v-deep.van-cell-group{
      margin-top: calc(var(--gap) * 12);
      overflow: hidden;
      background-color: transparent;
      .van-cell{
        color: var(--g8);
        // font-size:var(--fs-lg);
        // line-height:var(--lh-lg);
        .van-cell__title{
          flex: unset;
          color: var(--g7);
          font-family: PingFangSC-Semibold, PingFang SC;
          display: flex;
          align-items: center;     
          white-space: nowrap;
          margin-right: calc(var(--gap) * 24);  
        }
        .van-cell__value{
          display: flex;
          color: var(--g8);
          align-items: center;
          justify-content: flex-end;
        }
      }
      .cell-value-input{
        padding: 0;
        input{
          padding: calc(var(--gap) * 3) calc(var(--gap) * 8);
          &::placeholder{
            font-size:var(--fs-lg);
            line-height:var(--lh-lg);
          }
        }
      }
      .cell-extra-nav{
        display: flex;
        align-items: center;
        >i{
          transition: transform .3s ease-in-out;
        } 
        &.open>i{
          transform: rotateZ(180deg);
        }  
      }
      .check-cell {
        .important {
          color: var(--c3);
        }
        .van-cell__value{
          height: calc(var(--w) * 26);
          overflow: visible;
        }
      }
    }
    .cell-val-div{
      display: flex; 
      width: 100%; 
      justify-content: flex-end;
      &.disabled{
        color: var(--g5);
      }
    }
  }
  .example-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.9);
    .example-body {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      p {
        margin: calc(var(--gap) * 16);
        color: var(--white);
      }
      img {
        width: 100%;
        height: auto;
        &.non-full {
          display: block;
          width: 90%;
          margin: 0 auto;
        }
      }
      button {
        display: block;
        margin: calc(var(--gap) * 40) auto 0;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 40);
        color: var(--white);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        background-color: transparent;
        border-radius: var(--radius-lg);
        border: 1px solid #ffffff;
        box-shadow: unset;
      }
    }
  }
}

</style>